// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from "@/store/store";
import axios from 'axios'
import Vuetable from 'vuetable-2'
import Vuex from 'vuex';
import login from "@/store/modules/auth/login";

import "@icon/themify-icons/themify-icons.css"; // Themify Icons for Form Wizard

/** File Upload Library */
const VueUploadComponent = require("vue-upload-component");
Vue.component("file-upload", VueUploadComponent);


import "vue-select/dist/vue-select.css";
import vSelect from "vue-select"

Vue.component('v-select', vSelect)

import { ValidationObserver, ValidationProvider, configure } from 'vee-validate/dist/vee-validate.full';
import VueEvents from 'vue-events'
Vue.use(VueEvents)


import { extend } from 'vee-validate/dist/vee-validate.full';

extend('agreement', {
    validate: value => {
        return value;
    },
    message: 'You should agree to the continue /proceed.'
});

extend('valid_email', {
    validate: value => {
        const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return mailRegex.test(value);
    },
    message: 'Please enter a valid Email ID.'
});

extend("decimal", {
    validate: (value, { decimals = '2', separator = '.' } = {}) => {
        if (value === null || value === undefined || value === '') {
            return {
                valid: false
            };
        }
        if (Number(decimals) === 0) {
            return {
                valid: /^-?\d*$/.test(value),
            };
        }
        const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
        const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);
        return {
            valid: regex.test(value),
            data: {
                serverMessage: 'Only decimal values are available'
            }
        };
    },
    message: 'Only decimal values up to two digits are available'
})


import "animate.css/animate.css";
require("@/assets/css/custom.css");

import Snotify from 'vue-snotify';
import "vue-snotify/styles/material.css";
import Router from "vue-router";
Vue.use(Snotify);

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

import VuejsDialog from 'vuejs-dialog';

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import { abilitiesPlugin } from '@casl/vue'
Vue.use(abilitiesPlugin);

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('access_token') == null) {
            router.push("/login");
        } else {
            //let permissions =  login.state.user_permissions_state;

            var base64Url = login.state.access_token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            let payload = JSON.parse(jsonPayload);

            let permissions = payload.scopes;

            if (to.matched.some(record => record.meta.requiresAuth)) {
                if (permissions.indexOf(to.meta.permission) == -1) {
                    router.push("/login");
                } else {
                    next()
                }
            } else {
                next()
            }
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (localStorage.getItem('access_token') == null) {
            next({
                path: '/pages/access_denied',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
});



// todo
// cssVars()

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Vuetable)
Vue.use(Snotify)
Vue.component("v-select", vSelect)

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.component('loading', Loading);

//multi select
import Multiselect from 'vue-multiselect'
// register globally
Vue.component('multiselect', Multiselect);


import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import InputMask from 'vue-input-mask';
Vue.component('input-mask', InputMask);

// router.beforeEach((to, from, next) => {
//     if (login.getters.loggedIn() == false) {
//         router.push("/login");
//     } else {
//         next();
//     }
// });

Vue.directive('uppercase', {
    bind(el, _, vnode) {
        el.addEventListener('keyup', (e1) => {
            e1.target.value = e1.target.value.toUpperCase()
            vnode.componentInstance.$emit('input', e1.target.value.toUpperCase())
        })
    }
})

Vue.directive('lowercase', {
    bind(el, _, vnode) {
        el.addEventListener('keyup', (e1) => {
            e1.target.value = e1.target.value.toLowerCase()
            vnode.componentInstance.$emit('input', e1.target.value.toLowerCase())
        })
    }
})

import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);


// modal box
import VModal from 'vue-js-modal'
Vue.use(VModal)

import VueAnalytics from 'vue-analytics';

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: 'UA-177550063-1',
    router
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    Vuetable,
    VModal,
    template: '<App/>',
    components: {
        App
    },
    beforeCreate() {
        Vue.$snotify = this.$snotify;
    }
})